<div class="main_body">
  <app-page-header
    title="セクショングループ"
    i18n-title="@@adminSystem.sectionGroupList.title.list"
    subtitle="セクショングループの情報の閲覧・編集を行います。"
    i18n-subtitle="@@adminSystem.sectionGroupList.label.description"
    icon="section-group"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- M3 Expandable Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder" i18n="@@adminSystem.sectionGroupList.placeholder.filter">セクショングループ フィルター</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="'セクショングループ フィルター'"
              i18n-aria-label="@@adminSystem.sectionGroupList.search.ariaLabel"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSystem.sectionGroupList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <!-- Action buttons - right aligned -->
          <div class="table-toolbar__actions">
            @if (hasSectionGroupCreate || hasAllSectionGroupManagement || hasDistributorAgent) {
              <button mat-stroked-button
                      class="list-action-button"
                      (click)="openCreateSectionGroupDialog()">
                <span i18n="@@adminSystem.sectionGroupList.button.create">新規作成</span>
                <mat-icon>add</mat-icon>
              </button>
              <button mat-stroked-button
                      class="list-action-button"
                      [routerLink]="['/system-admin','create-section-group-and-section']">
                <span i18n="@@adminSystem.sectionGroupList.button.bulkCreate">まとめて作成</span>
                <mat-icon>playlist_add</mat-icon>
              </button>
            }
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSystem.sectionGroupList.tooltip.refresh"
              i18n-aria-label="@@adminSystem.sectionGroupList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="5" />
          } @else {
            <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status" matSortDirection="desc">

              <ng-container matColumnDef="sectionName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;" i18n="@@adminSystem.sectionGroupList.table.name">セクショングループ名</th>
                <td mat-cell *matCellDef="let row">
                  {{row.name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef style="min-width: 90px;" i18n="@@adminSystem.sectionGroupList.table.address"> 所在地 </th>
                <td mat-cell *matCellDef="let row">
                  {{row.addresses.prefecture + ' ' + row.addresses.city}}
                </td>
              </ng-container>

              <ng-container matColumnDef="admins" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 300px;" i18n="@@adminSystem.sectionGroupList.table.admins"> 管理者 </th>
                <td mat-cell *matCellDef="let row" >
                  @if (row.admins && row.admins.length > 0) {
                    <div>
                      @for (admin of row.admins; track admin) {
                        <div>
                          @if (admin.status.toUpperCase() == 'OPEN') {
                            <div>
                              <div [id]="row.id+'+'+admin.userId" class="container">
                                <div class="admin-box">
                                  <div> &nbsp;{{ admin.lastName }} {{ admin.firstName }}</div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openSectionGroupDetailDialog(row)" >
              </tr>
            </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
